/** Расширение файла вместе с точкой ('.pdf'); '' если расширения нет. Точку в начале (dotfile) расширением не считаем. */
export const getFileExtension = (name: string): string => {
    const dotIdx = name.lastIndexOf('.');
    return dotIdx > 0 ? name.slice(dotIdx) : '';
};

/**
 * setCellValue для колонки имени файла (EUPDEV-12263): переименовывать файл можно,
 * но исходное расширение фиксируется — удалить или сменить формат нельзя.
 * Расширение берём из неизменяемого _filename (оригинальное имя загруженного файла).
 */
export const setFileNameKeepingExtension = (newData: any, value: any, currentRowData: any): void => {
    const original: string = currentRowData?._filename ?? currentRowData?.AttachmentFileName ?? '';
    const ext = getFileExtension(original);
    const input = value == null ? '' : String(value);

    // отрезаем то, что пользователь ввёл как расширение, чтобы приклеить исходное
    let base: string;
    if (ext && input.toLowerCase().endsWith(ext.toLowerCase())) {
        base = input.slice(0, input.length - ext.length);
    } else {
        const lastDot = input.lastIndexOf('.');
        base = lastDot >= 0 ? input.slice(0, lastDot) : input;
    }

    if (!base.trim()) {
        // имя не может остаться пустым — возвращаем прежнюю основу
        const prev: string = currentRowData?.AttachmentFileName ?? original;
        const prevExt = getFileExtension(prev);
        base = (prevExt ? prev.slice(0, prev.length - prevExt.length) : prev) || prev;
    }

    newData.AttachmentFileName = base + ext;
};
